import type { Components, Theme } from "@mui/material/styles";

export const MuiFilledInput: Components<Theme>["MuiFilledInput"] = {
  defaultProps: {
    disableUnderline: true,
  },
};
